export type BrandType = 'just-only' | 'fightforyou'

interface Config {
  brand: BrandType
  environment: string
  userFrontEndpoint: string
  creatorFrontEndpoint: string
  businessFrontEndpoint: string
  apiEndpoint: string
  shareEndpoint: string
  userFrontDomain: string
  creatorFrontDomain: string
  businessFrontDomain: string
}

export const config: Config = {
  brand: (process.env.REACT_APP_BRAND as BrandType) ?? 'just-only',
  environment: process.env.REACT_APP_ENVIRONMENT ?? 'development',
  userFrontEndpoint: process.env.REACT_APP_USER_FRONT_ENDPOINT ?? '',
  creatorFrontEndpoint: process.env.REACT_APP_CREATOR_FRONT_ENDPOINT ?? '',
  businessFrontEndpoint: process.env.REACT_APP_BUSINESS_FRONT_ENDPOINT ?? '',
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT ?? '',
  shareEndpoint: process.env.REACT_APP_SHARE_ENDPOINT ?? '',
  userFrontDomain: process.env.REACT_APP_USER_DOMAIN ?? '',
  creatorFrontDomain: process.env.REACT_APP_CREATOR_DOMAIN ?? '',
  businessFrontDomain: process.env.REACT_APP_BUSINESS_DOMAIN ?? '',
}

interface ExternalLink {
  userLogin: string
  creatorLogin: string
}

export const externalLink: ExternalLink = {
  userLogin: `${config.userFrontEndpoint}/login`,
  creatorLogin: `${config.creatorFrontEndpoint}/login`,
}

// ブランド判定ヘルパー関数
export const isJustOnly = (): boolean => config.brand === 'just-only'
export const isFightForYou = (): boolean => config.brand === 'fightforyou'
export const getBrand = (): BrandType => config.brand
// プロジェクト名はブランドと同じなので getBrand() のエイリアス
export const getProjectName = (): string => config.brand
